'use client';

import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.js';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.js';
import { Link } from '@sola/ark-core/atoms/link/link.js';
import { Link as LinkSchema } from '@sola/schema/lib/schema.js';

interface LightboxButtonsProps {
  primaryCTA?: LinkSchema;
  secondaryCTA?: LinkSchema;
  tertiaryCTA?: LinkSchema;
  buttonSize?: 'sm' | 'md' | 'lg' | 'xl';
  inline?: boolean;
}

export const LightboxButtons: React.FC<LightboxButtonsProps> = ({
  primaryCTA,
  secondaryCTA,
  tertiaryCTA,
  buttonSize = 'md',
}) => {
  const renderButton = (
    cta: LinkSchema,
    variant: 'primary' | 'secondary' | 'tertiary',
    className?: string,
  ) => {
    if (!cta) {
      return null;
    }

    if (variant === 'tertiary') {
      return (
        <LinkStyle
          size={buttonSize}
          iconAfter="arrow-right"
          noPadding
          noUnderline
          inline
        >
          <Link
            download={cta.isDownload}
            href={cta.link}
            target={cta.target}
            className={className}
          >
            {cta.title}
          </Link>
        </LinkStyle>
      );
    }

    return (
      <ButtonStyle variant={variant} size={buttonSize}>
        <Link
          download={cta.isDownload}
          href={cta.link}
          target={cta.target}
          className={className}
        >
          {cta.title}
        </Link>
      </ButtonStyle>
    );
  };

  return (
    <div className="flex items-center justify-center gap-snug-lg">
      {primaryCTA && renderButton(primaryCTA, 'primary')}
      {secondaryCTA && renderButton(secondaryCTA, 'secondary')}
      {tertiaryCTA && renderButton(tertiaryCTA, 'tertiary', 'ml-snug-lg')}
    </div>
  );
};
